<template>
  <section class="ak--support">
    <div class="ak--support--wrapper">
      <v-container class="traffic-insurance">
        <h2 class="company-info--heading section-title-crosspage">
          {{ categoryInfo.mainTitle }}
        </h2>
        <v-row class="mr-0 mt-14 align-center">
          <v-col
            cols="12"
            sm="7"
            md="5"
            lg="5"
            xl="5"
            class="d-md-flex offset-sm-3 offset-md-0"
          >
            <v-img
              min-height="150"
              max-height="600"
              width="100%"
              :src="illustration"
              class="category-info-image"
            ></v-img>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7">
            <h3 class="traffic-insurance__heading">
              {{ categoryInfo.description.title }}
            </h3>
            <p
              class="traffic-insurance__text"
              v-for="parag in categoryInfo.description.content"
              :key="parag"
              v-html="parag"
            ></p>

            <h3 class="traffic-insurance__heading">
              {{ categoryInfo.subContent.title }}
            </h3>
            <div
              v-for="text in categoryInfo.subContent.content"
              :key="text.paragraph"
            >
              <p class="traffic-insurance__text" v-html="text.paragraph"></p>
              <ul v-if="text.subList">
                <li
                  class="traffic-insurance__list-item"
                  v-for="(sub, i) in text.subList"
                  :key="i"
                  v-html="sub"
                >
                  <!-- <span class="list-item--subheading">{{ sub.header }}</span>  bu kısma şimdilik ihtiyaç yok gerekirse açılacak -->
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    categoryInfo: {
      type: Object,
      require: true
    }
  },
  data () {
    return {}
  },
  computed: {
    illustration () {
      const arr = this.$route.path.split('/')
      const route = arr[1]
      const path = require(`@/assets/illustrations/${route}.svg`)
      return path
    }
  }
}
</script>
